import type {
  MemberListFetchParams,
  MemberSelectorFilters,
} from "../types.ts";
import { ALL_TEAMS_ID } from "./constants.ts";

type FilterSnapshot = {
  teamId: number | null;
  searchKeyword: string;
  filters: MemberSelectorFilters;
};

type BuildMemberListFetchParamsOptions = FilterSnapshot & {
  pageNum: number;
  pageSize: number;
  extraParams?: Record<string, any>;
};

export function buildMemberListFetchParams({
  pageNum,
  pageSize,
  teamId,
  searchKeyword,
  filters,
  extraParams,
}: BuildMemberListFetchParamsOptions): MemberListFetchParams {
  const params: MemberListFetchParams = {
    pageNum,
    pageSize,
    ...(extraParams ?? {}),
  };

  if (teamId !== ALL_TEAMS_ID) {
    params.teamId = teamId as number;
  }

  const trimmedKeyword = searchKeyword.trim();
  if (trimmedKeyword) {
    params.keyword = trimmedKeyword;
  }

  if (filters.personnelType) {
    params.personnelType = filters.personnelType;
  }

  if (filters.employmentStatus) {
    params.employmentStatus = filters.employmentStatus;
  }

  if (filters.status) {
    params.status = filters.status;
  }

  return params;
}

export function getActiveMemberFilterCount({
  teamId,
  searchKeyword,
  filters,
}: FilterSnapshot): number {
  let count = 0;

  if (teamId !== ALL_TEAMS_ID) {
    count += 1;
  }

  if (searchKeyword.trim()) {
    count += 1;
  }

  if (filters.personnelType) {
    count += 1;
  }

  if (filters.employmentStatus) {
    count += 1;
  }

  if (filters.status) {
    count += 1;
  }

  return count;
}

export function hasActiveMemberFilters(snapshot: FilterSnapshot): boolean {
  return getActiveMemberFilterCount(snapshot) > 0;
}
